import words from "./data/words.json";

let overrideWords = null;

export const WORDS = words;

export function setOverrideWords(newWords) {
  if (newWords && typeof newWords === "object") {
    overrideWords = newWords;
  } else {
    overrideWords = null;
  }
}

export function getWord(path, fallback) {
  if (!path) return fallback ?? "";

  const base = overrideWords || words;

  const segments = path.split(".");
  let current = base;

  for (const segment of segments) {
    if (current && Object.prototype.hasOwnProperty.call(current, segment)) {
      current = current[segment];
    } else {
      current = undefined;
      break;
    }
  }

  if (current === undefined || current === null) {
    return fallback ?? path;
  }

  return current;
}
